import {
  PORTFOLIOS_CREATE_ACTIONS,
  PORTFOLIOS_LIST_ACTIONS,
  PORTFOLIOS_EDIT_ACTIONS,
  PORTFOLIOS_DELETE_ACTIONS,
} from "../../../actionType/portfolios";
import { ADMIN_PORTFOLIOS_ACTIONS } from "../../../actionType/admin/portfolios";

const intialState = {
  portfoliosCreatData: {},
  isPortfoliosCreatLoader: false,
  portfoliosListAdmin: [],
  isPortfoliosListLoaderAdmin: false,
  portfoliosDeleteLoader: false,
  portfoliosDeleteData: {},
};

export const adminPortfolioReducer = (
  state = intialState,
  { type, payload }: any
) => {
  switch (type) {
    case ADMIN_PORTFOLIOS_ACTIONS.PORTFOLIOS_REQUEST:
      return { ...state, isPortfoliosCreatLoader: true };
    case ADMIN_PORTFOLIOS_ACTIONS.PORTFOLIOS_RESPONSE:
      return {
        ...state,
        portfoliosCreatData: payload,
        isPortfoliosCreatLoader: false,
      };
    case ADMIN_PORTFOLIOS_ACTIONS.PORTFOLIOS_ERROR:
      return {
        ...state,
        portfoliosCreatData: payload,
        isPortfoliosCreatLoader: false,
      };

    // PORTFOLIOS_LIST_ACTIONS

    case ADMIN_PORTFOLIOS_ACTIONS.PORTFOLIOS_LIST_REQUEST:
      return { ...state, isPortfoliosListLoaderAdmin: true };
    case PORTFOLIOS_CREATE_ACTIONS.PORTFOLIOS_RESPONSE:
      return {
        ...state,
        portfoliosListAdmin: payload,
        isPortfoliosListLoaderAdmin: false,
      };
    case ADMIN_PORTFOLIOS_ACTIONS.PORTFOLIOS_LIST_RESPONSE:
      return {
        ...state,
        portfoliosListAdmin: payload,
        isPortfoliosListLoaderAdmin: false,
      };

    // PORTFOLIOS_EDIT_ACTIONS

    case ADMIN_PORTFOLIOS_ACTIONS.PORTFOLIOS_EDIT_REQUEST:
      return { ...state, isPortfoliosCreatLoader: true };
    case ADMIN_PORTFOLIOS_ACTIONS.PORTFOLIOS_EDIT_RESPONSE:
      return {
        ...state,
        portfoliosCreatData: payload,
        isPortfoliosCreatLoader: false,
      };
    case ADMIN_PORTFOLIOS_ACTIONS.PORTFOLIOS_EDIT_ERROR:
      return {
        ...state,
        portfoliosCreatData: payload,
        isPortfoliosCreatLoader: false,
      };
    // PORTFOLIOS_DELETE_ACTIONS

    case ADMIN_PORTFOLIOS_ACTIONS.PORTFOLIOS_DELETE_REQUEST:
      return { ...state, portfoliosDeleteLoader: true };
    case ADMIN_PORTFOLIOS_ACTIONS.PORTFOLIOS_DELETE_REQUEST:
      return {
        ...state,
        portfoliosDeleteData: payload,
        portfoliosDeleteLoader: false,
      };
    case ADMIN_PORTFOLIOS_ACTIONS.PORTFOLIOS_DELETE_ERROR:
      return {
        ...state,
        portfoliosDeleteData: payload,
        portfoliosDeleteLoader: false,
      };
    default:
      return state;
  }
};
